(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-components"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-components')) {
    customElements.define('product-components', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        const panels = this.querySelectorAll('[role="tabpanel"]');

        const selectTab = (selectedTab) => {
          tabs.forEach((tab) => {
            const selected = tab === selectedTab;
            tab.setAttribute('aria-selected', String(selected));
            tab.tabIndex = selected ? 0 : -1;
          });
          panels.forEach((panel) => {
            panel.hidden = panel.id !== selectedTab.getAttribute('aria-controls');
          });
        };

        tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => selectTab(tab));
          tab.addEventListener('keydown', (event) => {
            let nextIndex;
            if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
            if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
            if (event.key === 'Home') nextIndex = 0;
            if (event.key === 'End') nextIndex = tabs.length - 1;
            if (nextIndex === undefined) return;
            event.preventDefault();
            selectTab(tabs[nextIndex]);
            tabs[nextIndex].focus();
          });
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
